module.exports = __webpack_public_path__ + "static/media/KevinHuang.74f61426.jpg";